import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Typography,
  Box,
  TextField,
  FormHelperText,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const ADMIN_PASSWORD = 'Young&sexy@!'; // Updated password as requested

function AdminDashboard() {
  const [submissions, setSubmissions] = useState([]);
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (authenticated) {
      const storedSubmissions = JSON.parse(localStorage.getItem('submissions') || '[]');
      setSubmissions(storedSubmissions);
    }
  }, [authenticated]);

  const exportToCSV = () => {
    const headers = ['First Name,Last Name,Email,Phone,Timestamp\n'];
    const csvRows = submissions.map(submission => 
      `${submission.firstName},${submission.lastName},${submission.email},${submission.phone},${submission.timestamp}`
    );
    const csvContent = headers + csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `submissions-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
    }
  };

  if (!authenticated) {
    return (
      <Container maxWidth="xs" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2, width: '100%', mt: 8 }}>
          <Typography variant="h5" align="center" gutterBottom>
            Admin Login
          </Typography>
          <form onSubmit={handleLogin}>
            <TextField
              fullWidth
              type="password"
              label="Admin Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              sx={{ mb: 2 }}
              autoFocus
            />
            {error && <FormHelperText error sx={{ mb: 2 }}>{error}</FormHelperText>}
            <Button type="submit" variant="contained" fullWidth sx={{ backgroundColor: '#D4AF37', '&:hover': { backgroundColor: '#B4941F' } }}>
              Login
            </Button>
          </form>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">Admin Dashboard</Typography>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={exportToCSV}
          sx={{
            backgroundColor: '#D4AF37',
            '&:hover': {
              backgroundColor: '#B4941F',
            },
          }}
        >
          Export to CSV
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>First Name</TableCell>
              <TableCell>Last Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Timestamp</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {submissions.map((submission, index) => (
              <TableRow key={index}>
                <TableCell>{submission.firstName}</TableCell>
                <TableCell>{submission.lastName}</TableCell>
                <TableCell>{submission.email}</TableCell>
                <TableCell>{submission.phone}</TableCell>
                <TableCell>{new Date(submission.timestamp).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}

export default AdminDashboard;
